const type = 'RESET_AGREEMENT_SUMARY';

const resetAgreementSummary = () => ({
  type,
});

export { type };
export default resetAgreementSummary;
